import React, { PropTypes } from 'react';
import MatchResultVoting from '../../../../../api/voting/matchResult';
import FullDatePicker from '../../../../form/FullDatePicker';
import ErrorContainer from '../../../../form/ErrorContainer';
import VotingToolBar from '../VotingToolBar';
import AnnounceMatchResultDialog from './AnnounceMatchResultDialog';
import VotingBaseForm from '../VotingBaseForm';

class MatchResultVotingForm extends VotingBaseForm {
  static propTypes = {
    model: PropTypes.instanceOf(MatchResultVoting),
    fields: PropTypes.shape({
      voting: PropTypes.object.isRequired,
      start_time: PropTypes.object.isRequired,
      end_time: PropTypes.object.isRequired
    }),
    disabled: PropTypes.bool
  };

  state = {
    openModal: false
  };

  prepareData() {
    let announcePromise = new Promise((res, rej) => this.setState({
      announcePromiseRes: res,
      announcePromiseRej: rej
    }));

    this.setState({ openModal: true, announcePromise });

    return announcePromise;
  }

  onSubmit({first_score, second_score}) {
    this.state.announcePromiseRes({
      first_score: parseInt(first_score),
      second_score: parseInt(second_score)
    });
    this.onClose();
    return this.state.announcePromise;
  }

  onClose() {
    this.state.announcePromiseRej(false);
    this.setState({
      openModal: false,
      announcePromise: null,
      announcePromiseRes: null,
      announcePromiseRej: null
    });
  }

  render() {
    let { fields: {start_time, end_time, voting}, disabled = false } = this.props;
    let { openModal } = this.state;

    return (
      <div>
        <ErrorContainer id="event_match_result_voting" displayLabel={false} error={voting.error} touched={true} style={{margin:0}}/>
        <FullDatePicker label="Start time" required disabled={disabled} {...start_time}/>
        <FullDatePicker label="End time" min={start_time.value} required disabled={disabled} {...end_time}/>
        <VotingToolBar needPublish prepareData={() => this.prepareData()} {...this.getToolbarOptions()}/>
        <AnnounceMatchResultDialog open={openModal}
                                   onClose={() => this.onClose()}
                                   onSubmit={(data) => this.onSubmit(data)} />
      </div>
    );
  }
}

export default MatchResultVotingForm;



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/MatchResultVoting/MatchResultVotingForm.jsx